// extracted by mini-css-extract-plugin
export default {"whatsappButton":"WhatsAppLogo_whatsappButton__m7Ihc","whatsappLogo":"WhatsAppLogo_whatsappLogo__Knbxq"};